function normalizeText(value) {
  return String(value ?? '')
    .toLocaleLowerCase('tr-TR')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function isUcretsizRevizyonSatis(satisTuruRef, satisTuruItems = []) {
  const selected = satisTuruItems.find(
    (item) => Number(item?.ST_REF) === Number(satisTuruRef)
  );
  return normalizeText(selected?.ST_AD).includes('revizyon');
}

export function normalizeUcretsizRevizyonPayload(satis, satisTuruItems = []) {
  if (!isUcretsizRevizyonSatis(satis?.CAS_SATIS_TURU, satisTuruItems)) return satis;
  // Revizyon satışında sıfır tutara izin ver; kullanıcı pozitif bir tutar
  // girdiyse bunu ücretsiz işlem varsayımıyla ezme.
  if (Number(satis?.CAS_SATIS_TUT) > 0) return satis;
  return {
    ...satis,
    CAS_SATIS_TUT: 0,
    CAS_ODE_SEKLI: satis?.CAS_ODE_SEKLI ?? 0,
    CAS_KALAN_TUT: 0,
  };
}
